import { Table } from "../../../../models/table";
import { CircularProgress, Typography } from "@mui/material";
import { useAddSystemTableOptionMutation, useEditSystemTableOptionByIdMutation, useGetSystemTableOptionsQuery } from "../../../../redux/api/system-tables.api";
import { useEffect, useState } from "react";
import { handleApiErrors } from "../../../../services/errorHandling";
import { useErrorBoundary } from "react-error-boundary";


interface SystemTableOptionsProps{
  systemTable: Table,
  returnBack: () => void,
  getModelsTable: (option: Table) => void
}

function SystemTableOptions({systemTable, returnBack, getModelsTable}: SystemTableOptionsProps) {

  const { showBoundary } = useErrorBoundary();

  const { 
    data: systemTableOptions, 
    isLoading: isFetchingSystemTableOptions
  } = useGetSystemTableOptionsQuery(systemTable.index);

  const [editSystemTableOption] = useEditSystemTableOptionByIdMutation();
  const [addSystemTableOption] = useAddSystemTableOptionMutation();

  const [action, setAction] = useState<string>("browse")
  const [systemTableOptionsCopy, setSystemTableOptionsCopy] = useState<Table[]>();



  useEffect(()=>{

    if(systemTableOptions){
      setSystemTableOptionsCopy(systemTableOptions);
    }
    
  },[systemTableOptions]);


  /**
   * save the edited system option in the state
   * @param event 
   * @param tableChanged 
   */
  function apdateState(event: React.ChangeEvent<HTMLInputElement>, tableChanged: Table): void{

    const systemTableOptionsToUpdate = systemTableOptionsCopy?.map(
      table => table.id === tableChanged.id ? { ...tableChanged, name: event.target.value } : table
    );

    setSystemTableOptionsCopy(systemTableOptionsToUpdate);
  }


  /**
   * save the edited system table option in db and store
   * @param option 
   */
  async function saveInput(option: Table){
    try {
      await editSystemTableOption({systemTableNumber: systemTable.index, option});
    } 
    
    catch (error) {
      handleApiErrors(error, showBoundary);
    }
  }
  

  /**
   * add a new option to a system table
   */
  async function addNewSystemTableOption(): Promise<undefined>{
    try {
      const optionIndex: number = (systemTableOptionsCopy?.length ?? 0) + 1;
      await addSystemTableOption({systemTableNumber: systemTable.index, optionIndex});
    } 
    
    catch (error) {
      handleApiErrors(error, showBoundary);
    }
    
  }


  return (
    <>
      { (isFetchingSystemTableOptions) && <CircularProgress color="inherit" sx={{ display: "block", margin: "auto", padding: 4 }} />}
      
      { !isFetchingSystemTableOptions && systemTableOptionsCopy && (
        <>
          <Typography variant="h3" className="title">
            טבלת {systemTable.name}
          </Typography>

          <div className="table-container">
            <table>
              <tbody>
                {
                  systemTableOptionsCopy.map((option, index) => (
                    <tr key={index}>
                      <td>{option.index}.</td>
                      {systemTable?.index === 1 ? (
                        <td className="expand clickable">
                          {action === 'browse' && <a className="clickable" onClick={() => { getModelsTable(option) }}>{option.name}</a>}
                          {action === 'edit' && <input value={option.name || ""} onChange={(e) => { apdateState(e, option) }} onBlur={() => { saveInput(option) }} />}
                        </td>
                      ) 
                      : 
                      (
                        <td className="expand" >
                          {action === 'browse' && option.name}
                          {action === 'edit' && <input value={option.name || ""} onChange={(e) => { apdateState(e, option) }} onBlur={() => { saveInput(option) }} />}
                        </td>
                      )}
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
          <div className="buttons">
            <button onClick={returnBack}>חזור</button>
            {action === 'browse' ? <button onClick={() => { setAction('edit') }}>עריכה</button> : <button onClick={() => { setAction('browse') }}>סיום עריכה</button>}
            <button onClick={addNewSystemTableOption}>הוספת שורה</button>
          </div>
        </>
      )}
    </>
  );
}

export default SystemTableOptions